module.exports = __webpack_public_path__ + "img/card1.3d8f7b04.png";